var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMontserrat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0038 16 0.00175 16 0C24.8365 0 32 7.1635 32 16Z",
    fill: "#0052B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9568 16.0001H15.9996C15.9996 15.9857 15.9996 15.9717 15.9996 15.9573C15.9853 15.9716 15.9711 15.9858 15.9568 16.0001Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.34781C16 5.5325 16 3.68781 16 0H15.9973C7.16194 0.0015 0 7.16431 0 16H8.34781V11.2993L13.0485 16H15.9572C15.9715 15.9857 15.9858 15.9715 16.0001 15.9572C16.0001 14.8793 16.0001 13.9174 16.0001 13.0486L11.2992 8.34781H16Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09515 2.08691C5.59271 3.51185 3.51228 5.59223 2.0874 8.09466V16H6.26134V6.26098V6.26085H16.0005C16.0005 4.94441 16.0005 3.69029 16.0005 2.08691H8.09515Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0006 14.0325L10.3159 8.3479H8.34839V8.34803L16.0005 16H16.0006C16.0006 16 16.0006 14.6433 16.0006 14.0325V14.0325Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0874 8.3479V16C18.0874 19.7275 22.957 20.8696 22.957 20.8696C22.957 20.8696 27.8265 19.7275 27.8265 16V8.3479H18.0874Z",
    fill: "#338AF3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0874 15.9999C18.0874 19.7274 22.957 20.8695 22.957 20.8695C22.957 20.8695 27.8265 19.7274 27.8265 15.9999H18.0874Z",
    fill: "#A2001D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0433 11.8262H23.6519V10.4348H22.2606V11.8262H20.8694V13.2174H22.2606V17.3913H23.6519V13.2174H25.0433V11.8262Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMontserrat);
export default __webpack_public_path__ + "static/media/montserrat.5f129186.svg";
export { ForwardRef as ReactComponent };